import { Axios } from '@/config/axios'

const state = {
}

const getters = {
}

const actions = {
  remoteUninstall ({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post('/api/remote-uninstall', data)
        .then((response) => {
          resolve(response.data)
        })
        .catch(function (error) {
          reject(error.response?.data || { message: 'Une erreur est survenue' })
        });
    });
  },
  editAgentName ({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post('/api/gestion/edit-agent-name', data)
        .then((response) => {
          resolve(response.data)
        })
        .catch(function (error) {
          reject(error.response)
        });
    });
  },
}

const mutations = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
